<template src="./Index.html"></template>

<script>
    import BarChart from "@/components/charts/BarChart.js";

export default {
  components: {
        BarChart,
  },
  created() {
    this.getSalesByMonth();
  },

  data() {
    return {
      salesByMonth: {},
      month: [
        "يناير",
        "فبراير",
        "مارس",
        "ابريل",
        "مايو",
        "يونيو",
        "يوليو",
        "اغسطس",
        "سبتمبر",
        "اكتوبر",
        "نوفمبر",
        "ديسمبر",
      ],
    };
  },
  methods: {
    getSalesByMonth() {
      this.$store.dispatch("dashboard/getSalesByMonth").then((res) => {
        this.salesByMonth = {
          labels: this.month,
          datasets: [
            {
              label: "",
              backgroundColor: "#83c783",
              data: res.counts,
            }, 
           
          
          ],
        };
      });
    },
  },
};
</script>
